import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { useToast } from '../../view/components/ui/use-toast'
import {
  getChartConsults,
  GetChartConsultsParams,
} from '../services/consultService/getChartConsults'

interface UseChartConsultsHookProps {
  interval?: number | false
}

export const useChartConsults = ({
  interval = false,
}: UseChartConsultsHookProps) => {
  const [params, setParams] = useState<GetChartConsultsParams>({
    groupBy: 'DAY',
  })

  const { data, isLoading, isFetching, isError } = useQuery({
    queryKey: ['consults', 'chartConsults', params],
    queryFn: () => getChartConsults(params),
    refetchInterval: interval,
    placeholderData: keepPreviousData,
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title:
          'Erro ao carregar os dados do gráfico de consultas. Tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    data,
    isLoading,
    isFetching,
    setParams,
  }
}
